import React from 'react'
import { formatPrice } from 'common/helpers'
import { FormattedHTMLMessage, FormattedMessage } from 'sb-react-intl'

import messages from './messages'
import s from './MonthOption.scss'


const MonthOption = ({ option: { productCount, productPrice, totalPrice } }) => (
  <div className={s.option}>
    <FormattedMessage {...messages.title} values={{ count: productCount }} />
    <FormattedHTMLMessage
      className={s.totalPrice}
      tag="div"
      {...messages.totalPrice}
      values={{ value: formatPrice(totalPrice, true) }}
    />
    <FormattedMessage
      className={s.scentPrice}
      tag="div"
      {...messages.scentPrice}
      values={{ value: formatPrice(productPrice, true) }}
    />
  </div>
)


export default MonthOption
